import { toast } from 'react-toastify';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { api } from '~/services/api';
import { ResponseProps } from '../../../propsGlobal/responseProps';
import {
  anonymFailure,
  anonymRequest,
  anonymSuccess,
  deleteAnonymFailure,
  deleteAnonymRequest,
  deleteAnonymSuccess,
  postAnonymFailure,
  postAnonymRequest,
  postAnonymSuccess,
} from './actions';
import { AnonymTypes } from './types';

function* getAnonym({ payload }: ReturnType<typeof anonymRequest>) {
  try {
    const response: ResponseProps = yield call(api.get, '/v1/AnonymRequests');

    yield put(anonymSuccess(response.data));
  } catch (error) {
    yield put(anonymFailure());
  }
}

function* postAnonym({ payload }: ReturnType<typeof postAnonymRequest>) {
  try {
    const response: ResponseProps = yield call(
      api.post,
      '/v1/AnonymRequests',
      null,
      {
        headers: {
          'g-recaptcha-response': payload.recaptcha,
        },
      },
    );

    yield put(postAnonymSuccess(response.data));
    yield put(anonymRequest());
    toast.success(
      'Solicitação efetuada com sucesso! O processo de anonimização finalizará após o cumprimento do prazo legal da retenção dos dados.',
    );
  } catch (error) {
    yield put(postAnonymFailure());
  }
}

function* deleteAnonym({ payload }: ReturnType<typeof deleteAnonymRequest>) {
  try {
    const response: ResponseProps = yield call(
      api.delete,
      '/v1/AnonymRequests',
      {
        headers: {
          'g-recaptcha-response': payload.recaptcha,
        },
      },
    );

    yield put(deleteAnonymSuccess(response.data));
    toast.success('Solicitação efetuada com sucesso!');
  } catch (error) {
    yield put(deleteAnonymFailure());
  }
}

export default all([
  takeLatest(AnonymTypes.ANONYM_RESQUEST, getAnonym),
  takeLatest(AnonymTypes.POST_ANONYM_RESQUEST, postAnonym),
  takeLatest(AnonymTypes.DELETE_ANONYM_RESQUEST, deleteAnonym),
]);
